<template>
  <div class="joblist_search">
    <div class="cont">
      <input
        ref="keyword"
        name="keyword"
        placeholder="请输入你要搜索的职位名称"
        class="keyword"
      />
      <a href="javascript:;" class="btn" @click="search()">
        <icon
          name="search"
          class="icon"
          :width="iconWidth"
          :height="iconHeight"
        ></icon>
      </a>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      iconWidth: 26,
      iconHeight: 26,
      solveList: [],
    };
  },
  props: ["onsearch"],
  created() {
    let me = this;
    me._ResizeId = me.resizer.onWidth(768, function (w) {
      if (w > 768) {
        me.iconWidth = 26;
        me.iconHeight = 26;
      } else {
        me.iconWidth = 12;
        me.iconHeight = 12;
      }
    });
    me.resizer.trigger();
  },
  beforeDestroy: function () {
    var me = this;
    me.resizer.un(me._ResizeId);
  },
  methods: {
    search: function () {
      let me = this;
      let keyword = this.$refs.keyword.value;
      me.onsearch && me.onsearch(keyword);
    },
  },
};
</script>

<style lang="scss" scoped>
.joblist_search {
  width: 100%;
}

.joblist_search .cont {
  width: 70%;
  max-width: 805px;
  margin: 50px auto;
  overflow: hidden;
}

.joblist_search .keyword {
  width: 88%;
  height: 66px;
  border: 1px solid #0a41ff;
  text-indent: 30px;
  float: left;
  border-radius: 33px 0 0 33px;
}

.joblist_search .btn {
  width: 10%;
  height: 66px;
  line-height: 66px;
  text-align: center;
  background: #0a41ff;
  border: 1px solid #0a41ff;
  float: left;
  border-radius: 0 33px 33px 0;
}

.joblist_search .btn:hover,
.joblist_search .btn:active {
  background: #0a41ff;
  border: 1px solid #0a41ff;
}

.joblist_search .icon {
  fill: #fff;
  transform: translateY(7px);
}

.home_solve {
  width: 100%;
  padding: 50px 0;
  background-color: #ffffff;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
}

.solve_content {
  padding-top: 60px;
  width: 70%;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
}

.text {
  bottom: 0;
  font-size: 40px;
  font-family: PingFang SC;
  font-weight: 500;
  line-height: 40px;
  color: #4473c9;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 25px;
}
</style>